import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from './_enums/ENUM__page_generation_layout';
import { G_LAYOUT__image_edit_master } from './layouts/assets_images/G_LAYOUT__image_edit_master';
import { G_PAGE_LAYOUT__generation_bundles } from './layouts/bundles/G_PAGE_LAYOUT__generation_bundles';
import { G_LAYOUT__generation_nodes } from './layouts/nodes/G_LAYOUT__generation_nodes';
import { G_PAGE_LAYOUT__generation_outputs } from './layouts/outputs/G_PAGE_LAYOUT__generation_outputs';

export function G_PAGE_LAYOUT_DESKTOP__generation() {
  const { g_general__layout } = use_slice_ui(['g_general__layout']);

  /*
   *
   */

  /*
   * RENDERS
   */

  function render_layout() {
    let out_map = new Map<ENUM__page_generation_layout, JSX.Element>([
      [ENUM__page_generation_layout.NODES, <G_LAYOUT__generation_nodes />],
      [ENUM__page_generation_layout.ASSETS, <G_LAYOUT__image_edit_master />],
      [ENUM__page_generation_layout.OUTPUTS, <G_PAGE_LAYOUT__generation_outputs />],
      [ENUM__page_generation_layout.BUNDLES, <G_PAGE_LAYOUT__generation_bundles />],
    ]);

    return out_map.get_or_assert(g_general__layout);
  }

  /*
   * HTML
   */

  return render_layout();
}
